import * as Yup from "yup";

// Yup validation schema
export const createAccountSchemaValidation = Yup.object().shape({
  taiKhoan: Yup.string()
    .min(4, "Tài khoản đăng nhập cần từ 4 ký tự")
    .required("Không được để trống"),
  matKhau: Yup.string(),
  name: Yup.string().required("Không được để trống"),
});
